import { render, staticRenderFns } from "./BaseVideoRow.vue?vue&type=template&id=2982e095&"
import script from "./BaseVideoRow.vue?vue&type=script&lang=js&"
export * from "./BaseVideoRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseVideoRow.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports